/* eslint eol-last: ["error", "never"] */
export default {
    loading: false,
    categoriaslist: true,
    categoriasadd: false,
    categorias: [],
    documentos: [],
}